import request from '@/utils/request'

export function index(params) {
  return request({
      url: '/settings/staff_work_types',
      method: 'get',
      params: params
  })
}

export function show(id) {
  return request({
      url: `/settings/staff_work_types/${id}`,
      method: 'get'
  })
}

export function store(data) {
  return request({
      url: '/settings/staff_work_types',
      method: 'post',
      data
  })
}

export function update(data) {
  return request({
      url: `/settings/staff_work_types/${data.id}`,
      method: 'put',
      data
  })
}


export function inventory(params) {
  return request({
      url: '/settings/staff_work_type/inventory',
      method: 'get',
      params
  })
}

export function destroy(id) {
  return request({
      url: `/settings/staff_work_types/${id}`,
      method: 'delete',
  })
}
